import { WorkOrder, WorkOrderDetailType } from '@atom/types/work';
import {
  SearchWorkTemplate,
  WorkTemplate,
  WorkTemplateItem,
  WorkTemplateListItem,
} from '@atom/types/workTemplate';
import { isWorkDateEditingRestricted } from '@atom/utilities/tenantFeatureUtilities';

type WorkWithPreferences =
  | WorkOrderDetailType
  | WorkOrder
  | WorkTemplate
  | WorkTemplateItem
  | WorkTemplateListItem
  | SearchWorkTemplate;

export const showWorkDueDateTime = (
  work?: WorkWithPreferences | null,
): boolean =>
  !!work?.appointmentsEnabled || !!work?.preferences?.dateTimeEnabled;

export const showWorkDateTime = (work?: WorkWithPreferences | null): boolean =>
  !!work?.preferences?.dateTimeEnabled;

// Disables editing of the work-order-level due and completed dates. NCE work
// orders derive them from their tasks, so hand edits would be overwritten.
// Scoped to OCP rather than stored as a preference.
export const isWorkDateEditingDisabled = (
  work?: WorkWithPreferences | null,
): boolean =>
  isWorkDateEditingRestricted && !!work?.preferences?.dateTimeEnabled;
